import { useDispatch, useSelector } from 'react-redux';
import { DoubleArrowLeft, DoubleArrowRight } from '@rsos/assets/icons';
import { toggleQueueCollapse } from '@rsos/reduxDataStore/src/features/queue/queueSlice';
import useHasAccessToUniteEventPane from '../../../../hooks/useHasAccessToUniteEventPane';
import { ActionBarItem } from '../ActionBarItem';

const CollapseQueueActionBarItem = () => {
  const dispatch = useDispatch();
  const hasAccessToUniteEventPane = useHasAccessToUniteEventPane();
  const isCollapsed = useSelector(state => state.queue?.isQueueCollapsed);

  const handleCollapseQueue = () => {
    dispatch(toggleQueueCollapse());
  };

  return (
    <ActionBarItem
      id="action-bar-item-collapse"
      onClick={handleCollapseQueue}
      tooltipText={isCollapsed ? 'Expand queue' : 'Collapse queue'}
      shouldRender={hasAccessToUniteEventPane}
    >
      {isCollapsed ? <DoubleArrowRight /> : <DoubleArrowLeft />}
    </ActionBarItem>
  );
};

export default CollapseQueueActionBarItem;
